// ##############################
// // // SweetAlert view styles
// #############################
import merge from  'lodash/merge';
import buttonStyle from "../components/buttonStyle.jsx";
import { textAlignValues } from "../stylesConstants";

const sweetAlertStyle = {
  cardTitle: {
    marginTop: "0",
    marginBottom: "3px",
    color: "#3C4858",
    fontSize: "18px"
  },
  center: {
  },
  right: {
  },
  left: {
  }
};

sweetAlertStyle.center = textAlignValues.center;
sweetAlertStyle.right = textAlignValues.right;
sweetAlertStyle.left = textAlignValues.left;
merge(sweetAlertStyle, buttonStyle);  

export default sweetAlertStyle;
